module.exports = __webpack_public_path__ + "img/circle-cross.917a4908.svg";